import * as yup from 'yup'

import { getCouponCode } from 'src/deps'

const couponCodeSchema = Object.assign({}, getCouponCode())
export const schema = yup.object(couponCodeSchema)
